import { BuyersAsyncActions } from 'store/actions/buyers';
import { createReducerFromActions } from 'utils/store';
import { values } from 'lodash';

export default createReducerFromActions(...values(BuyersAsyncActions));
